<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->

  </div>
</template>
<script>
export default {
  name: "App",
  beforeRouteEnter (to, from, next) {
    console.log("00000000000000");
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    if (from.path != "/") {
      // 如果不是刷新则赋值1
      sessionStorage.removeItem("myCurrentPage");
    }
    next();
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      console.log("0000000000000000000000000000000000000");
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },

  beforeDestroy () {

    localStorage.removeItem('temporaryId');
    window.onbeforeunload = function (e) {
      // 监听窗口关闭术语提示
      // var e = event || window.event;
      // var x = e.screenX
      // var y = e.screenY

      e = e || window.event;
      //兼容IE8和Firefox 4之前的版本
      if (
        (event.clientX > document.body.clientWidth && event.clientY < 0) ||
        event.altKey
      ) {
        e.returnValue = "关闭提示";
      }
      // if (window.is_confirm !== false) {
      //   console.log('进入----------------------------');
      //   return "关闭提示";
      // }

    };
  }

};
</script>

<style lang="less" scoped>
#app {
  font-family: "Microsoft YaHei";
  // "Avenir", Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #454545;
  height: 100%;
}
#nav {
  padding: 30px;
  width: 500px;
  height: 400px;
  background: #2c3e50;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
